export const CustomerType = {
  INDIVIDUAL: 'individual',
  BUSINESS: 'business',
} as const;

export type CustomerType = (typeof CustomerType)[keyof typeof CustomerType] | null;

export const ContactReasonType = {
  POLICY: 'policy',
  CLAIM: 'claim',
  OTHERS: 'others',
} as const;

export type ContactReason = (typeof ContactReasonType)[keyof typeof ContactReasonType] | null;
